export default "__VITE_ASSET__CdvqrfKc__"